import { render, staticRenderFns } from "./DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit.vue?vue&type=template&id=28c64838&scoped=true&"
import script from "./DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit.vue?vue&type=script&lang=js&"
export * from "./DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c64838",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
